// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__LKoyG","row":"ProcedureTreatmentSummary_row__1js1B"};